var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Icon, Text } from '@springcare/sh-component-library';
import { isBefore, isSameDay } from 'date-fns';
import { useFlagValue } from 'flagging/hooks';
import { useMemo } from 'react';
import { Benefits, BenefitsTerminated } from 'shared/assets/icons';
import { formatCalendarDate } from 'shared/utils';
export var MemberTerminationBanner = function (_a) {
    var terminateAt = _a.terminateAt;
    var deactivatingCopyFlagValue = useFlagValue('MEMBER_DEACTIVATING_COPY');
    var isTerminating = !!terminateAt;
    var isTerminated = isTerminating &&
        (isBefore(new Date(terminateAt), new Date()) || isSameDay(new Date(terminateAt), new Date()));
    var copy = useMemo(function () {
        return (isTerminated
            ? "Client account deactivated. This client's Spring Health benefit expired on {{date}}."
            : deactivatingCopyFlagValue).replace('{{date}}', formatCalendarDate(terminateAt));
    }, [deactivatingCopyFlagValue, isTerminating, isTerminated]);
    var backgroundColor = "".concat(isTerminated ? 'neutral' : 'warning', "-subtle");
    var icon = isTerminated ? BenefitsTerminated : Benefits;
    if (!isTerminating)
        return _jsx(_Fragment, {});
    return (_jsxs(HStack, __assign({ spacing: 2, px: 4, py: 2, backgroundColor: backgroundColor, mb: 3, mt: -4, mx: -4 }, { children: [_jsx(Icon, { boxSize: 4, as: icon }), _jsx(Text, __assign({ "data-testid": "memberDeactivationBanner" }, { children: copy }))] })));
};
